import React, { useState, useEffect } from "react";

const RunbookDescription = ({ description, editable, sendDataToParent }) => {
  const [localDescription, setLocalDescription] = useState("");

  useEffect(() => {
    setLocalDescription(description);
  }, [description]);

  const handleChange = (e) => {
    setLocalDescription(e.target.value);
  };

  const handleSave = () => {
    sendDataToParent(localDescription);
  };
  
  return (
    !editable ? 
      <p className="text-start" style={{ color: "#DBE1F5", fontSize: "15px", paddingLeft: "1%" }}>
        {description}
      </p>
      :
      <textarea
        className="form-control text-start"
        value={localDescription}
        onChange={handleChange}
        onBlur={handleSave}
        style={{ color: "#DBE1F5", fontSize: "14px", width: "100%", minHeight: "50px" }}
      />
  );
};

export default RunbookDescription;